import "./style.scss";
import Header from "./components/Header";
import UploadImage from "components/Onboard/components/UploadImage";
import Footer from "./components/Footer";
import Divider from "components/BaseWidgets/divider";
import { useMyProfile } from "hooks/api/useProfile";
import { retrieveToken } from "utils/storage";

function ManagePhotos({ managePhotoView = false, setManagedPhoto, user }) {
  const userData = JSON.parse(retrieveToken("user") || "{}");
  const { data: profileData, isLoading: profileLoading } = useMyProfile(
    userData?.aec_id
  );

  const imageapproved =
    profileData?.user_images?.map((img) => img.is_approved) || [];

  return (
    <div className="manage-photo-container">
      <Header
        managePhotoView={managePhotoView}
        setManagedPhoto={setManagedPhoto}
      />
      <UploadImage
        user={user}
        isFromProfile
        profileData={profileData}
        profileLoading={profileLoading}
        managePhotoView={managePhotoView}
        setManagedPhoto={setManagedPhoto}
        imageapproved={imageapproved}
      />
      <Divider />
      <Footer />
    </div>
  );
}

export default ManagePhotos;
